import FooterSection from "@/components/FooterSection.vue";
import Navigatie from "@/components/Navigatie.vue";
import { useMenusStore } from "@/stores/menusStore";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  data() {
    return {
      // baseUrl: 'http://localhost:3000/api/menus'
      baseUrl: "https://tahdik-restaurant.onrender.com/api/menus",
      store: useMenusStore(),
      currentPagina: this.$route.name,
      pages: [
        { name: "Home", path: "/" },
        { name: "Menu", path: "/menu" },
        { name: "Reserveren", path: "/reserveren" },
        { name: "Contact", path: "/contact" },
      ],

      notification: "",
      notificationTimeout: null,
      progress: 100,
      progressInterval: null,

      innerScrollHeight: null,
    };
  },

  mounted() {
    this.updateInnerScrollHeight();
    window.addEventListener("scroll", this.updateInnerScrollHeight);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.updateInnerScrollHeight);
  },

  components: {
    "font-awesome-icon": FontAwesomeIcon,
    Navigatie,
    FooterSection,
  },

  computed: {
    menus() {
      return this.store.menus;
    },
  },

  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    fetchMenus() {
      this.store.fetchMenus();
    },
    getMenuById(id) {
      this.store.fetchMenuById(id);
    },
    deleteMenu(id) {
      this.store.deleteMenu(id);
    },

    async showNotification(message) {
      this.notification = message;
      this.progress = 100;
      if (this.notificationTimeout) clearTimeout(this.notificationTimeout);
      if (this.progressInterval) clearInterval(this.progressInterval);

      // Progress bar animatie
      const duration = 5000; // 5 seconden
      const interval = 100; // ms
      const step = 100 / (duration / interval);

      this.progressInterval = setInterval(() => {
        this.progress -= step;
        if (this.progress <= 0) {
          this.progress = 0;
          clearInterval(this.progressInterval);
        }
      }, interval);

      this.notificationTimeout = setTimeout(() => {
        this.notification = "";
        clearInterval(this.progressInterval);
      }, duration);
    },

    updateInnerScrollHeight() {
      const scrollY = window.scrollY;

      scrollY > 2000 ? (this.innerScrollHeight = true) : (this.innerScrollHeight = false);
    },
  },
};
